import { EditOutline, TrashIcon } from "components/LEGACY/styled-components/Icons"
import CopyableString from "components/utils/CopyableString"
import Toggle from "components/utils/Toggle"
import { DocumentReference, deleteDoc, updateDoc } from "firebase/firestore"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import DiscountCode from "types/firestore/discountCode"
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./DiscountCodes.module.scss"

interface DiscountCodeListLineProps {
  discountCode: WithRef<DiscountCode>
  setModal: (ref: DocumentReference<DiscountCode> | undefined) => void
}
export default function DiscountCodeListLine({ discountCode, setModal }: DiscountCodeListLineProps) {
  const {
    type,
    value,
    countUsed,
    limitUses,
    active,
    //neededMinOrderValue,
    // availableOrderModes,
  } = discountCode
  const setActive = (v: boolean) => {
    updateDoc(discountCode._ref, { active: v })
  }
  const valueString =
    type === "euro"
      ? new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value / 100)
      : type === "percent"
        ? `${value} %`
        : ""
  const deleteAvailable = countUsed === 0 && !active
  const deleteCode = async (ref: DocumentReference) => {
    await deleteDoc(ref)
  }
  const openEditModal = () => setModal(discountCode._ref)
  return (
    <tr>
      <td>
        <div style={{ display: "flex" }}>
          <Toggle {...{ state: active, setState: setActive }} />
          <button onClick={openEditModal}>
            <EditOutline color="currentColor" />
          </button>
          {deleteAvailable && (
            <button onClick={() => deleteCode(discountCode._ref)}>
              <TrashIcon size="16" color="currentColor" />
            </button>
          )}
        </div>
      </td>
      <td>
        <CopyableString stringToCopy={discountCode._ref.id} />
      </td>
      <td onClick={openEditModal} className={styles.right}>
        {valueString}
      </td>
      <td onClick={openEditModal} className={styles.right}>
        {countUsed}/{limitUses || "∞"}
      </td>
    </tr>
  )
}
